import React from "react";
import { Link } from "react-router-dom";
import {
  FaBookmark,
  FaHeart,
  FaLayerGroup,
  FaStore,
  FaTools,
} from "react-icons/fa";
import { getOwnProfileSectionPath } from "../../utils/profilePaths";
import { usePublicPages } from "../../contexts/PublicPagesContext";
import SuggestedUsersPanel from "./SuggestedUsersPanel";
import styles from "../../styles/pages/feed/FeedPage.module.css";

const FeedRightSidebar = ({ currentUser }) => {
  const { isPageEnabled } = usePublicPages();

  return (
    <aside className={styles.feedSidebar}>
      <div className={styles.sidebarCard}>
        <h3>
          <FaLayerGroup /> Quick Access
        </h3>
        <div className={styles.navList}>
          <Link
            to={getOwnProfileSectionPath(currentUser, "/saved")}
            className={styles.navItem}
          >
            <FaBookmark /> Collections
          </Link>
          <Link
            to={getOwnProfileSectionPath(currentUser, "/favorites")}
            className={styles.navItem}
          >
            <FaHeart /> Favorites
          </Link>
          <Link
            to={getOwnProfileSectionPath(currentUser, "/setup")}
            className={styles.navItem}
          >
            <FaTools /> My Setup
          </Link>
          {isPageEnabled("marketplace") && (
            <Link to="/marketplace" className={styles.navItem}>
              <FaStore /> Marketplace
            </Link>
          )}
        </div>
      </div>

      <div className={styles.sidebarDivider} />

      <div className={styles.sidebarCard}>
        <SuggestedUsersPanel />
      </div>
    </aside>
  );
};

export default React.memo(FeedRightSidebar);
